// extracted by mini-css-extract-plugin
export default {"inputStyles":"pure-file-upload_inputStyles__V7QFK","label":"pure-file-upload_label__D9evJ","required":"pure-file-upload_required__vquDI"};